import ErrorBoundary from "../../../Shared/Components/ErrorBoundary"
import Footer2 from "../../../Shared/Components/Footer/Footer2"
import CacheProvider from "../../../Shared/cache/cacheProvider"
import Loader from '../../../Shared/Components/Loader/Loader'
import { useEffect, useState } from "react"
import { changeImageSrcToCdn } from "../../../Shared/helper/helper"
import { Helmet } from "react-helmet"
import { getMetaData } from "../../../Shared/service"
import { useLocation } from "react-router-dom"
import { sendEvent } from "../../../Shared/service/eventService"
import { generateEventPageName } from "../../../Shared/helper/helper"
import Header from "../../../Shared/Components/Header/Header"

const LandingPageLayout = (props) => {
  const [metaData, setMetData] = useState({});
  const location = useLocation();
   const [currentPageTags,setCurrentPageTags]=useState({})

  const fetchMetaData = () => {
    getMetaData().then((res) => {
      let data = JSON.parse(res?.data?.packageHtml)
      if (res?.data?.packageHtml) setMetData(data)
        let path=location?.pathname
        if(location?.pathname=='/'){
           path = path?.replace('/', 'landingPage');
        }else{
          path = path?.replace('/', '');
        }
      setCurrentPageTags(data?.[path])
    }).catch((err) => console.log(err))
  }

  useEffect(() => {
    let imgList = document.getElementsByTagName("img");
    // fetchMetaData();
    changeImageSrcToCdn(imgList);
  }, []);

  return (
    <div className="landing-page-layout">
      <CacheProvider>
        {/* {currentPageTags && <Helmet>
          <title>{currentPageTags?.title}</title>
          <meta name="name" content={location?.pathName} />
          <meta name="og:description" content={currentPageTags?.description} />
          <meta name="og:url" content={location?.pathName} />
          <meta name="og:title" content={currentPageTags?.title} />
          <meta name="description" content={currentPageTags?.description} />
          <meta name="og:url" content={location?.pathName} />
          <meta name="title" content={currentPageTags?.title} />
          <meta name="Keywords" content={currentPageTags?.description} />
        </Helmet>} */}
        <Loader />
        <Header/>
        <ErrorBoundary>
          {props.children}
        </ErrorBoundary>
        <Footer2/>
      </CacheProvider>
    </div>
  )
}

export default LandingPageLayout;